export default __webpack_public_path__ + "static/media/mentalHealthJourney.49433c90.svg";